/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';
import deleteIcon from '../../../../assets/images/logos/delete.png';
import noteIcon from '../../../../assets/images/logos/note.png';

export const FullCalendarWrapper = styled.div`
 	@media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
		max-width: 1350px;
	} 
	.calendar__title {
		position: relative;
		margin-bottom: 15px;
	}
	.calendar__body {
		overflow-y: auto;
		&::-webkit-scrollbar {
			width: 10px;
		}
		&::-webkit-scrollbar-track {
			background: #f1f1f1;
		}
		&::-webkit-scrollbar-thumb {
			background-color: ${({ theme }) => theme.colors.primary};
			border-radius: 10px;
			border: 2px solid #f1f1f1;
		}
		&::-webkit-scrollbar-thumb:hover {
			background-color: ${({ theme }) => theme.colors.primaryLight};
		}
	}
	.fc table {
		border-color: ${({ theme }) => theme.colors.separator};
	}
	.fc-scrollgrid-sync-table {
		height: 1000px;
	}
	.fc-theme-standard .fc-scrollgrid,
	.fc-theme-standard .fc-list,
	.fc-theme-standard td,
	.fc-theme-standard th {
		border: 1px solid ${({ theme }) => theme.colors.separator};
		background-clip: padding-box;
	}
	.fc-theme-standard td {
		border: 1px solid ${({ theme }) => theme.colors.separatorTable};
		background-clip: padding-box;
	}

	.fc-theme-standard th {
		background-color: ${({ theme }) => theme.colors.calendar};
	}

	.fc-col-header-cell {
		border: 1px solid transparent !important;
	}
	.fc .fc-list-table tr > * {
		border: none !important;
	}
	.fc .fc-daygrid-day.fc-day-today {
		//background-color: rgb(108 41 245 / 0.1);
	}
	.fc .fc-list-event:hover td {
		background-color: ${({ theme }) => theme.colors.itemBackground};
	}
	.fc .fc-list-empty {
		background-color: ${({ theme }) => theme.colors.itemBackground};
	}
	.fc-theme-standard .fc-list-day-cushion {
		background-color: ${({ theme }) => theme.colors.itemBackground};
		color: ${({ theme }) => theme.colors.text};
	}
	.fc .fc-scrollgrid-section-sticky > * {
		background-color: ${({ theme }) => theme.colors.background};
		color: ${({ theme }) => theme.colors.text};
	}
	.fc .fc-button {
		border-radius: 5px;
	}
	.fc-day-today {
		background-color: ${({ theme }) => theme.colors.itemBackground} !important;
	}
	td.fc-day-today {
		background-color: ${({ theme }) => theme.colors.background} !important;
	}
	.fc .fc-button-primary {
		background-color: ${({ theme }) => theme.colors.itemBackground};
		color: ${({ theme }) => theme.colors.itemColor};
		border: 1px solid ${({ theme }) => theme.colors.separator};
	}
	.fc .fc-button-active,
	.fc .fc-button-primary:not(:disabled):active,
	.fc .fc-button-primary:not(:disabled).fc-button-active {
		background-color: ${({ theme }) => theme.colors.secondary} !important;
		border-color: ${({ theme }) => theme.colors.secondary} !important;
		color: #ffffff;
	}
	.fc .fc-button:focus {
		box-shadow: 0 0 0 2px #cbd5e1 !important;
	}
	.fc .fc-today-button {
		border-radius: 5px !important;
		@media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
			margin-right: 12px;
		}
		
	}
	.fc-prev-button {
		border-radius: 5px 0 0 5px !important;
	}
	.fc-next-button {
		border-radius: 0 5px 5px 0 !important;
	}
	.fc-non-business {
		background-color: '#FAFAFC';
	}
	.fc-col-header-cell-cushion {
		padding: 10px;
		font-size: 14px;
		text-transform: uppercase;
	}

	.fc-col-header-cell-cushion{
		@media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
			font-size: 11px;
		}
		font-size: 1em;
		
	}

	.fc-timeGridDay-button , .fc-timeGridWeek-button, .fc-prev-button , .fc-today-button, .fc-next-button {
		@media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
			font-size: 14px;
		}
		font-size: 1em;
	}

	.fc-timegrid-axis-cushion{
		@media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
			font-size: 14px;
		}
		font-size: 1em;
	}

	.fc .fc-header-toolbar.fc-toolbar {
		margin-bottom: 24px;
		.fc-toolbar-chunk {
			&:first-child {
				@media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
					.fc-today-button {
						margin: 0;
					}
					.fc-prev-button,
				}
			}
		}
		@media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
			display: flex;
			flex-direction: row-reverse;
			.fc-toolbar-chunk {
				.fc-toolbar-title {
					font-size: 14px;
				}
				&:last-child {
					/* display: none; */
				}
			}
		}
	}
	.indispo .fc-event-title::before {
		display: inline-block;
		padding: 5px 5px 0px 5px;
		content: url(${deleteIcon});
	}

	.activityWithcomment .fc-event-title::before {
		display: inline-block;
		content: url(${noteIcon});
		padding: 1px 6px 1px 5px;
	}

	.activity .fc-event-main {
		color: ${({ theme }) => theme.colors.textBlack} !important;
	}
	.fc-timegrid-slot {
		background-color: ${({ theme }) => theme.colors.calendar};
	}
	.fc .fc-bg-event {
		background-color: ${({ theme }) => theme.colors.background} !important;
		opacity: 0.6;
	}

	.current-date {
		color: ${({ theme }) => theme.colors.secondary} !important;
		font-weight: bold;
		text-decoration: underline;
		text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.4);
		background-color: ${({ theme }) => theme.colors.primaryLight} !important;
		border-radius: 50%;
		width: 30px;
		height: 30px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.activity .fc-event-time {
		display: none;
	}
	.activity .fc-event-title {
		
		@media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
			font-size: 10px;
		}
		font-size: 12px;
	}

	.addScrollBar {
		overflow-y: scroll;
		max-height: 80px;
	}
	.fc-daygrid-day-events {
		height: 80px;
	}
	.fc-timeGridWeek-button {
		@media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
			margin-right : 1px;
		}
	}
	.fc .fc-timegrid-slot-label-cushion {
		@media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
			font-size: 14px;
		}
	}	
`;
export const StyledCalendarHeader = styled.div`
	display: flex;
	justify-content: space-between;
`;
export const StyledContainer = styled.div`
	h2 {
		text-align: center;
	}
	width: 60%;
	margin: auto;
	padding: 32px;
	@media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
		width: 40%;
	}
	@media (max-width: ${({ theme }) => theme.breakpoints.md}) {
		width: 100%;
	}
`;
export const StyledTitleContainer = styled.div`
	margin-top: 12px;
	margin-bottom: 24px;
`;
export const StyledError = styled.p`
	color: ${({ theme }) => theme.colors.error};
`;
export const StyledBlock = styled.span`
	width: 100%;
	display: inline-block;
	position: relative;
	text-align: center;
`;
export const StyledVersionContainer = styled.div`
	display: flex;
	flex-direction: column;
	color: ${({ theme }) => theme.colors.muted};
	font-size: 14px;
`;
export const StyledBlockModal = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
`;
export const StyledBlockIconComment = styled.span`
	position: absolute;
	right: 28px;
	top: 14px;
`;
export const StyledBlockComment = styled.div`
	position: absolute;
	margin-top: 100px;
	font-size: 12px;
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
`;
